<template>
	<div class="muti-table">
		<base-table
			:maxHeight="maxHeight"
			:distanceTop="distanceTop"
			:defaultSort="defaultSort"
			:columns="columns"
			:stickyHeader="stickyHeader"
			:list="list"
			:options="options"
			ref="baseTable"
			:selectionChange="selectionChange"
			:reserveSelection="reserveSelection"
			:rowClick="rowClick"
			:isShowHeader="isShowHeader"
			:tabName="tabName"
			:spanMethod="spanMethod"
			:selectable="selectable"
			:sortChange="sortChange"
			:cellMouseLeave="cellMouseLeave"
			:cellMouseEnter="cellMouseEnter"
			:cellStyle="cellStyle"
		>
			<template slot="empty" v-if="$slots.empty">
				<slot name="empty"></slot>
			</template>
		</base-table>
		<bottomfixed v-if="showPager && stickyHeader && pageFixed" :subtract-width="subtractWidth" class="botton-fixed">
			<yx-pagination
				class="yx-pagination"
				v-show="showPager"
				:total="total"
				:current-page="pageInfo.page_index"
				:page-size="pageInfo.page_size"
				:layout="layout"
				@size-change="sizeChange"
				@current-change="currentChange"
			>
				<template #total>
					<slot name="total"></slot>
				</template>
			</yx-pagination>
		</bottomfixed>
		<yx-pagination
			v-if="(!stickyHeader && showPager) || !pageFixed"
			:total="total"
			:current-page="pageInfo.page_index"
			:page-size="pageInfo.page_size"
			:layout="layout"
			@size-change="sizeChange"
			@current-change="currentChange"
		>
			<template #total>
				<slot name="total"></slot>
			</template>
		</yx-pagination>
	</div>
</template>
<script>
import bottomfixed from '@/components/ui/bottomFixed/bottomFixed.vue';
export default {
	components: {
		bottomfixed,
	},
	name: 'shopLibrary',
	props: {
		columns: {
			type: Array,
			default: () => {
				return [];
			},
		},
		list: {
			type: Array,
			default: () => {
				return [];
			},
		},
		options: {
			type: Object,
			default: () => {
				return {};
			},
		},
		total: {
			type: [String, Number],
			default: 0,
		},
		selectionChange: {
			type: Function,
			default: () => {
				return () => {};
			},
		},
		rowClick: {
			type: Function,
			default: () => {
				return () => {};
			},
		},
		reserveSelection: {
			type: Boolean,
			default: false,
		},
		isShowHeader: {
			type: Boolean,
			default: () => {
				return true;
			},
		},
		tabName: {
			type: [String, Number],
			default: () => {
				return '0';
			},
		},
		selectable: {
			type: Function,
			default: () => {
				return () => {};
			},
		},
		layout: {
			type: String,
			default: 'total, sizes, prev, pager, next, jumper',
		},
		page: {
			type: Object,
			default: () => ({
				page_size: 10,
			}),
		},
		defaultSort: {
			type: Object,
			default: () => {},
		},
		stickyHeader: {
			type: Boolean,
			default: true,
		},
		showPager: {
			type: Boolean,
			default: true,
		},
		subtractWidth: {
			type: Number,
			default: 0,
		},
		distanceTop: {
			type: Number,
			default: 65,
		},
		maxHeight: {
			type: [Number, String],
			default: 'default',
		},
		cellMouseEnter: {
			type: Function,
			default: () => {
				return () => {};
			},
		},
		cellMouseLeave: {
			type: Function,
			default: () => {
				return () => {};
			},
		},
		spanMethod: {
			type: Function,
			default: () => {
				return () => {};
			},
		},
		cellStyle: {
			type: Function,
			default: () => {
				return () => {};
			},
		},
		pageFixed: {
			type: Boolean,
			default: true,
		}, // 是否开启底部分页器固定
	},
	watch: {
		page: {
			handler(val) {
				this.pageInfo.page_size = val.page_size;
				this.pageInfo.page_index = val.page_index;
			},
			immediate: true,
		},
	},
	data() {
		return {
			pageInfo: {
				page_index: 1,
				page_size: 10,
				item_total: 0,
			},
		};
	},
	computed: {
		//过滤要筛选的字段
		screenList() {
			return this.columns.filter(item => item.isSearch);
		},
	},
	methods: {
		sizeChange(val) {
			this.pageInfo.page_size = val;
			this.pageInfo.page_index = 1;
			this.$emit('gePartnerList', this.pageInfo);
		},
		currentChange(val) {
			this.pageInfo.page_index = val;
			this.$emit('gePartnerList', this.pageInfo);
		},
		resetPage() {
			this.pageInfo = {
				page_index: 1,
				page_size: this.page.page_size,
				item_total: 0,
			};
		},
		sortChange(sort) {
			this.pageInfo.page_index = 1;
			this.$emit('getSortList', { ...this.pageInfo, ...sort });
		},
		toggleSelection(rows, e) {
			this.$refs.baseTable.toggleSelection(rows, e);
		},
	},
};
</script>
<style lang="less" scoped>
.muti-table {
	margin-bottom: 60px;
}
.yx-pagination {
	position: absolute !important;
	right: 12px !important;
}
</style>